'use strict';
const angular = require('angular');
import { saveAs } from 'file-saver';

/*@ngInject*/
export function notificationService(Util, Auth, common, $http, $timeout, socket) {
  var safeCb = Util.safeCb;
  var notifications = [];
  var initialised = false;
  var activeNotifications = 0;

  return {
    initialise(callbackSuccess, callbackError) {
      var that = this;
      //if(!initialised) {
      if(!initialised && Auth.isLoggedInSync()) {
        common.setLoading(true);
        var promise = $http.get('/api/notifications/me');
        promise.then(response => {
          try {
            notifications = response.data;
            this.setActives();
            socket.syncUpdates('notification', notifications, function(e, notification, newNotificationArray) {
              console.log('Syncing...new notification');
              if (e == 'created') {
                Auth.getCurrentUser(function(user){
                  console.log(user._id, 'vs', notification._user);
                  if (user._id == notification._user) {
                    console.log('Adding...');
                    notifications.unshift(notification);
                    activeNotifications = activeNotifications + 1;
                    console.log("ACTIVES:", that.getActives());
                  }
                });
              }
            });
            common.setQuickNotification('notification loaded', 'success');
            initialised = true;
            safeCb(callbackSuccess)(response.data);
          } catch(e) {
            console.log(e);
            common.setQuickNotification('Error loading notification', 'danger');
            safeCb(callbackError)(err);
          }
        }).catch(err => {
          if(err.status != 401 && err.status != 404) {
            common.setAlert('Error', 'danger', `Error getting notification. Please try again. (Error ${err.status}: ${err.statusText})`, false, true);
          }
          if (err.status == 404) {
            common.setQuickNotification('No notification found', 'danger');
          }
          if(callbackError) {
            safeCb(callbackError)(err.data);
          } else if(callbackSuccess) {
            safeCb(callbackSuccess)(err.data);
          }
        });
      } else {
        safeCb(callbackSuccess)([]);
      }
    },

    resetNotifications() {
      initialised = false;
    },

    getNotifications() {
      return notifications;
    },

    getActives() {
      if (!initialised && Auth.isLoggedInSync) {
        this.initialise(function(){ common.setLoading(false); }, function(){ common.setLoading(false); });
      } else {
        return activeNotifications;
      }
    },

    setActives() {
      activeNotifications = 0;
      for (var n=0; n<notifications.length; n++) {
        if (notifications[n].active) activeNotifications++;
      }
    },

    findNotificationById(id) {
        return notifications.map(function(note){ return note._id; }).indexOf(id);
    },

    markAllRead() {
      for (var n=0; n<notifications.length; n++) {
        this.markAsRead(notifications[n]._id, function(){}, function(){});
      }
    },

    markAsRead(notificationId, callbackSuccess, callbackError) {
      common.setQuickNotification('Posting message...', 'info');
      var noteIndex = this.findNotificationById(notificationId);
      notifications[noteIndex].active = false;
      activeNotifications = activeNotifications - 1;
      if (activeNotifications < 0) activeNotifications = 0;
      var promise = $http.put(`/api/notifications/${notificationId}`, { active: false });
      promise.then(response => {
        try {
          $timeout(function() {
            common.setQuickNotification('Message posted.', 'success');
          }, 400);
          safeCb(callbackSuccess)(response.data);
        } catch(e) {
          console.log(e);
        }
      }).catch(err => {
        if(err.status != 401 && err.status != 404) {
          common.setAlert('Error', 'danger', `Error posting message.  Please try again!\n\r(Error ${err.status}: ${err.statusText})`, false, true);
        }
        if(callbackError) {
          safeCb(callbackError)(err.data);
        } else if(callbackSuccess) {
          safeCb(callbackSuccess)(err.data);
        }
      });
    }
  };
}

export default angular.module('ffApp.notifications', [])
  .service('notifications', notificationService)
  .name;



// WEBPACK FOOTER //
// ./client/components/notifications/notifications.service.js